export const ID41 = () => {
    return (
        <div>
            <div className="content" readonly=""><h1>1С:MES Оперативное управление производством</h1>

                <img src="https://cybernetica.kz/uploads/gallery/601242757.png" alt=""/>

                <ul >
                    <li>
                        <strong>Управление данными о составе изделий:&nbsp;</strong>управление данными о составе готовой
                        продукции и полуфабрикатов, о маршрутах прохождения
                        изделий по производственным подразделениям и складам.
                    </li>
                    <li>
                        <strong>Управление портфелем производственных заказов:&nbsp;</strong>формирование перечня
                        заказов на производство, расчет сроков исполнения
                        производственных заказов и их последующая корректировка.
                    </li>
                    <li>
                        <strong>Оперативное планирование производства:&nbsp;</strong>формирование этапов производства,
                        построение графика (APS-уровень) и расписания
                        производства (MES-уровень), оперативный контроль производства и реагирование на отклонения от
                        заданного графика, перерасчет расписания производства.
                    </li>
                    <li>
                        <strong>Диспетчеризация производства:&nbsp;</strong>формирование производственных заданий,
                        оперативное отражение хода исполнения операций, контроль
                        сроков исполнения производственных операций, формирование отчетов производства и сдельных
                        нарядов, проведение контроля качества.
                    </li>
                </ul>

                <h2>Управление данными о составе изделий</h2>
                <p >
                    Управление данными о составе готовой продукции и полуфабрикатов, о маршрутах прохождения изделий по
                    производственным подразделениям и складам – важный
                    элемент процесса управления производством.
                </p>

                <p>
                    Исходной информацией для планирования производства и материальных расходов на изготовление продукции
                    служит нормативно-справочная информация (НСИ) об
                    изделии. Основным средством планирования материальных расходов на изготовление продукции являются
                    ресурсные спецификации:
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/427448277.png" alt=""/>

                <p>
                    Ресурсная спецификация содержит перечень материалов и других составляющих, используемых при
                    производстве изделия. Все описания материалов, полуфабрикатов,
                    комплектующих и готовых изделий хранятся в информационной базе, что упрощает процесс составления
                    спецификаций и, в конечном итоге, облегчает планирование и
                    управление. В спецификации также может храниться информация о плановых нормах отходов, получаемых в
                    процессе обработки деталей. Для каждого последующего
                    передела, предыдущий полуфабрикат будет исходным комплектующим. Комплектующее или готовое изделие
                    может состоять из любых других элементов списка
                    номенклатуры. В свою очередь, оно может быть включено в спецификацию другого изделия.
                </p>

                <p>
                    В ресурсной спецификации содержатся этапы производства, которые описывают процесс изготовления
                    изделий. Для описания технологического процесса, выполняемого
                    в рамках этапа ресурсной спецификации, используются маршрутные карты.
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/1179904578.png" alt=""/>

                <p >
                    Для целей оперативного планирования производства весь технологический процесс в 1С:MES можно
                    представить в виде последовательной комбинации маршрутных карт
                    производства – описаний наборов технологических операций. Структура объектов для описания состава
                    изделий идентична применяемой в 1С:ERP, и при совместном
                    использовании 1С:MES и 1С:ERP информация между системами синхронизируется.
                </p>

                <p >
                    Формировать состав изделия и НСИ можно как встроенными в продукт средствами, так и с помощью
                    интеграции 1С:MES с PDM/PLM-системами, в которых формируется
                    состав изделия и маршрут его изготовления, осуществляется материальное и трудовое нормирование.
                </p>

                <p >
                    В качестве PDM-системы может выступать программный продукт&nbsp;<a
                    href="https://solutions.1c.ru/catalog/plm">1С:PDM 4 (PLM)</a>. При этом, входящие в
                    поставку 1С:MES механизмы обмена данными с продуктом 1С:PDM 4 (PLM) позволяют передавать НСИ об
                    изделии в ресурсные спецификации для дальнейшего
                    планирования производства.
                </p>

                <h2>Управление портфелем производственных заказов</h2>

                <p >
                    Подсистема предназначена для формирования количественных и календарных потребностей в продукции и
                    полуфабрикатах. Сроки исполнения производственных заказов
                    рассчитываются исходя из фактических возможностей производства, и корректируются при отражении
                    исполнения операций. Есть возможность объединения нескольких
                    заказов на производство в один запуск производства.
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/1179904578.png" alt=""/>

                <p>Структура заказа позволяет увидеть потребность в продукции и полуфабрикатах. Здесь можно подобрать
                    готовые или незавершенные заделы.</p>

                <img src="https://cybernetica.kz/uploads/gallery/2089123855.png" alt=""/>

                <p>На основании структуры заказа формируются этапы производства:</p>
                <img src="https://cybernetica.kz/uploads/gallery/404687667.png" alt=""/>

                <h2>Оперативное планирование производства</h2>

                <p>Основными задачами подсистемы являются:</p>
                <ul >
                    <li>
                        формирование расписания в соответствии с заданными критериями оптимизации, для выполнения
                        заданного объема работ с учетом ограничений и сложившейся
                        производственной ситуации на момент расчета;
                    </li>
                    <li>контроль сроков исполнения контрольных значений (заказов, этапов производства, технологических
                        операций);
                    </li>
                    <li>оперативный контроль производства и реагирование на отклонения от заданного графика, перерасчет
                        расписания для отражения управленческих решений.
                    </li>
                </ul>

                <p>
                    Для решения задачи построения расписания в 1С:MES применяется математический аппарат теории
                    расписаний, в частности эвристический алгоритм, сочетающий
                    "жадные" стратегии и стратегии ограниченного перебора, элементы теории графов. Рассматривается
                    частный случай построения расписания выполнения работ с
                    учетом отношений предшествования и ограничений на ресурсы, с прерываниями обслуживания требований
                    (PRCPSP - Preemption Resource-Constrained Project
                    Scheduling Problem). Алгоритм позволяет размещать технологические операции на оси времени рабочих
                    центров без дискретных интервалов и с учетом следующих
                    ограничений:
                </p>

                <ul >
                    <li>условия предшествования технологических операций;</li>
                    <li>доступность основных рабочих центров;</li>
                    <li>транспортировка между рабочими центрами или между подразделениями;</li>
                    <li>наличие необходимых для выполнения операций товарно-материальных ценностей.</li>
                </ul>

                <h2>Матрица транспортировок</h2>
                <p>
                    Для учета времени перемещения заготовок между смежными операциями предназначена Матрица
                    транспортировок. Если смежные операции выполняются на рабочих
                    центрах одного подразделения, то система при планировании будет использовать время транспортировки
                    между данными рабочими центрами. Если смежные операции
                    выполняются на рабочих центрах, закрепленных за разными подразделениями, то при планировании
                    учитывается время на перемещение между данными подразделениями.
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/1254971623.png" alt=""/>

                <h2>Расчет графика производства</h2>
                <p>
                    График производства рассчитывается в соответствии с приоритетами заказов, опираясь на данные из
                    заказов на производство и этапов производства. Назначение
                    графика производства – наглядно отобразить срок исполнения заказа и этапов производства,
                    рассчитанных системой, и соотношение его с директивным сроком
                    исполнения заказа.
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/336894866.png" alt=""/>

                <h2>Планирование расписания производства</h2>
                <p>
                    Расписание производства отражает конкретные рабочие центры и операции, назначенные на рабочие
                    центры, в соответствии с графиками работы рабочих центров, а
                    также с учетом выбранных ограничений и критериев оптимизации.
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/1776406251.png" alt=""/>

                <h2>Перепланирование графика производства</h2>
                <p>
                    В случаях возникновения брака, поломки оборудования, отставания от плановых показателей времени
                    выполнения операций, происходит отклонение от графика
                    производства. Для актуализации данных по производству изделия необходимо осуществить
                    перепланирование графика производства.
                </p>

                <h2>Диспетчеризация производства</h2>
                <p>
                    Основные цели диспетчеризации – обеспечение и поддержание нормального протекания производственного
                    процесса без сбоев и без нарушений принятого на
                    предприятии производственного цикла, а также обеспечение прослеживаемости выпуска готовой продукции
                    на всех стадиях ее изготовления. Формирование
                    исполнимого оперативного плана производства невозможно без обратной связи о ходе исполнения
                    запланированных операций. Основными задачами подсистемы
                    диспетчеризации производства являются:
                </p>

                <ul >
                    <li>Формирование производственных заданий на выполнение производственных операций;</li>
                    <li>Оперативное отражение хода исполнения операций;</li>
                    <li>Контроль сроков исполнения производственных операций;</li>
                    <li>Формирование документов выпуска.</li>
                </ul>

                <h2>Формирование производственных заданий</h2>
                <p>
                    Расписание производства является источником данных, на основании которых формируются
                    производственные задания на выполнение производственных операций.
                    Благодаря производственному заданию можно оперативно назначать исполнителей для выполнения
                    необходимого количества производственных операций, а не делать
                    это пооперационно. Выбирать операции для производственного задания можно как вручную, так и по
                    условиям.
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/916546399.png" alt=""/>

                <h2>Управление производственными операциями</h2>
                <p>
                    Функциональность предназначена для навигации по назначенным к исполнению этапам производства и
                    управления ходом производства в режиме реального времени. Для
                    каждого этапа производства операции отображаются с привязкой к рабочему центру и нормативным
                    временем исполнения с учетом установленных отборов.
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/1855436603.png" alt=""/>

                <p>
                    Система позволяет формировать производственные операции на основании технологических операций,
                    отмечать начало и завершение их выполнения, частичное
                    выполнение, а также указывать одного или нескольких исполнителей с учетом коэффициента трудового
                    участия (КТУ). Операции, не исполненные по каким-либо
                    причинам, при выполнении процедуры перепланирования повторно размещаются на графике загрузки
                    оборудования и планируются к выполнению.
                </p>

                <h2>Отражение факта исполнения операции</h2>
                <p >При завершении производственной операции фиксируется следующая информация:</p>
                <ul >
                    <li>фактический срок исполнения;</li>
                    <li>фактическое количество выполненных операций и операций, которые можно выполнить.</li>
                </ul>
                <p >Информация заполняется автоматически и может быть изменена.</p>
                <img src="https://cybernetica.kz/uploads/gallery/523223538.png" alt=""/>

                <h2>Работа с производственными терминалами</h2>

                <p>
                    Для упрощенного взаимодействия оператора с терминалом в системе предусмотрена возможность создания
                    штрихкодов для сотрудников, этапов производства и
                    операций. На печатной форме отображаются штрихкоды этапа производства и операций, выполняемых в
                    рамках этапа. Это позволяет осуществлять упрощенный поиск в
                    системе в процессе диспетчеризации производства.
                </p>
                <img src="https://cybernetica.kz/uploads/gallery/111887427.png" alt=""/>

                <h2>Отчет производства за смену</h2>
                <p>Отчет производства за смену предназначен для оперативного отражения сведений по:</p>
                <ul >
                    <li>выпуску продукции за смену;</li>
                    <li>количеству израсходованных в течение смены материалов.</li>
                </ul>

                <img src="https://cybernetica.kz/uploads/gallery/235124299.png" alt=""/>

                <h2>Отчет о составе смены</h2>
                <p>
                    Информацию о составе конкретной смены можно получить из отчета "Сдельная заработная плата", в
                    котором выводятся все выполненные технологические операции и
                    их исполнители за определенный период.
                </p>
                <img src="https://cybernetica.kz/uploads/gallery/1259564842.png" alt=""/>

                <h2>Формирование сдельных нарядов</h2>

                <p>
                    Функциональность предназначена для регистрации фактической сдельной выработки в управленческом,
                    бухгалтерском и налоговом учете, затрат, а также для целей
                    исчисления заработной платы:
                </p>
                <ul >
                    <li>в сдельном наряде описываются выполненные работы;</li>
                    <li>отражается состав исполнителей (например, бригада рабочих), выполнивших работу.</li>
                </ul>
                <img src="https://cybernetica.kz/uploads/gallery/615670120.png" alt=""/>

                <h2>
                    Отражение в этапе производства фактически выполненных работ
                </h2>
                <h2>

                    <p>
                        Фактически выполненные исполнителем работы, фактический расход материалов и выпуск продукции
                        отражаются на соответствующих вкладках Этапа производства.
                        В дальнейшем эта информация может быть передана в учетные системы, например, в 1С:ERP.
                    </p>

                    <img src="https://cybernetica.kz/uploads/gallery/1602651.png" alt=""/>

                </h2>
                <h2>Проведение контроля качества</h2>
                <p>
                    Для каждой операции в маршрутной карте можно указать вид контроля качества. Операция, требующая
                    контроля, после простановки отметки о завершении
                    появляется в форме "Управление техническим контролем".
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/391531291.png" alt=""/>

                <p>
                    Для оформления результатов проведения контроля используется документ "Предъявление на контроль". При
                    обнаружении брака имеется возможность указать
                    количество несоответствующей продукции, тип несоответствия (Допустимое, Исправимое, Неисправимое) и
                    вид несоответствия.
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/579365003.png" alt=""/>
                <p>На основании типа несоответствия создается соответствующий документ в системе:</p>
                <ul >
                    <li>тип несоответствия "Допустимое" – документ "Карта разрешения";</li>
                    <li>тип несоответствия "Исправимое" – документ "Этап производства" на исправление брака;</li>
                    <li>тип несоответствия "Неисправимое" – документ "Движение номенклатуры на складах".</li>
                </ul>

                <h2>Передача номенклатуры на склад</h2>
                <p>
                    На основании выполненной производственной операции, завершенного этапа производства или предъявления
                    на контроль можно передать номенклатуру на склад.
                    Продукт позволяет вести учет движения и состояния незавершенного производства, готовой и
                    забракованной продукции.
                </p>
                <img src="https://cybernetica.kz/uploads/gallery/1919910092.png" alt=""/>

                <h3 ><strong>Ролевой подход к организации рабочих мест</strong></h3>
                <p >
                    В конфигурации реализован ролевой подход к организации рабочих мест. Набор ролей, достаточный для
                    выполнения пользователями определенных функций,
                    соответствующих должностным обязанностям, формирует профиль пользователя.
                </p>
                <h3 ><strong>Интеграционные возможности</strong></h3>
                <p >
                    Информация о структуре предприятия, нормативно-справочной информации об изделии, поступивших заказах
                    и этапах производства, содержащаяся в справочниках
                    1С:ERP, может быть передана для планирования производства в 1С:MES. Информация о результатах
                    планирования и выполненных производственных операциях может
                    быть передана из 1С:MES в 1С:ERP для расчета себестоимости продукции. Передача информации между
                    1С:ERP и 1С:MES осуществляется встроенными в 1С:MES
                    механизмами обмена.
                </p>
                <p >
                    Интеграция продукта с 1С:PDM 4 (PLM) позволяет использовать в качестве исходных данных для
                    планирования производства в 1С:MES нормативно-справочную
                    информацию об изделии, сформированную в PLM-системе (состав изделия и маршрут его изготовления,
                    результаты материального и трудового нормирования).
                </p>
                <p >
                    Пользователи "1С:Управление производственным предприятием" могут приобрести "Модуль 1С:MES
                    Оперативное управление производством для 1С:Управление
                    производственным предприятием. Специальная поставка. Электронная поставка" (артикул 2900002245806),
                    который содержит встроенные механизмы интеграции с
                    "1С:Управление производственным предприятием", редакция 1.3
                </p>
                <h3 ><strong>Технологические преимущества</strong></h3>
                <p >
                    Решение "1С:MES Оперативное управление производством" разработано на новейшей версии технологической
                    платформы "1С:Предприятие 8.3", которая позволяет:
                </p>
                <ul >
                    <li>обеспечить высокую надежность, производительность и масштабируемость системы;</li>
                    <li>
                        организовать работу с системой через Интернет, в режиме тонкого клиента или веб-клиент (через
                        обычный интернет-браузер), в том числе в "облачном"
                        режиме;
                    </li>
                    <li>создавать мобильные рабочие места с использованием планшетов и иных мобильных устройств;</li>
                    <li>
                        настраивать интерфейс для конкретного пользователя или группы пользователей с учетом роли
                        пользователя, его прав доступа и индивидуальных настроек.
                    </li>
                </ul>
                <p >
                    Механизм функциональных опций, реализованный в "1С:MES Оперативное управление производством",
                    позволяет "включать" или "выключать" различные
                    функциональные части прикладного решения без программирования (изменения конфигурации).
                </p>
            </div>
        </div>
    )
}